import React, {FunctionComponent, useContext} from 'react';
import {ThemeContext} from "../../../context/ThemeContext";
import {Theme} from "../../../models/theme.model";
import styled from "styled-components";
import "./Button.scss";
import {BROWSER_BREAKPOINTS, UI_PARAMS} from "@flicent/fieldpulse-react-component-library-frontend";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {

}

const StyledButton = styled.button`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.branding_color};
    color: ${props => props.theme.text_contrast_color};

    &:hover {
      background: ${props => props.theme.branding_dark_color};
    }
    
    @media (${BROWSER_BREAKPOINTS.MOBILE}) {
      justify-content: center;
    }

    &.secondary-button {
      background: ${props => props.theme.branding_light_color};
      color: ${props => props.theme.text_light_contract_color};

      &:hover {
        background: ${props => props.theme.branding_color};
        color: ${props => props.theme.text_contrast_color};
      }
    }
    
    &.white-button {
      background: white;
      color: #1c1c1c;
      border: 1px solid #cbcbcb;

      &:hover {
        background: white;
        color: #1c1c1c;
      }
    }
    
    &.green-button {
      background: #86cc40;
      color: white;

      &:hover {
        background: #86cc40;
        color: white;
      }
    }

    &.cancel-button {
      background: #ff6347;
      color: white;

      &:hover {
        background: #c4442d;
      }
    }
    
    &.fp-button {
      background: ${UI_PARAMS.FP_BRANDING_COLOR};
      color: white;

      &:hover {
        background: ${UI_PARAMS.FP_BRANDING_COLOR};
      }
    }

    &.fp-outline-button {
      background: white;
      color: ${UI_PARAMS.FP_BRANDING_COLOR};
      border: 1px solid ${UI_PARAMS.FP_BRANDING_COLOR};

      &:hover {
        background: white;
      }
    }

    &.add-signature-button {
      font-weight: bold;
      box-shadow: 0 3px 3px #044704;
    }
    
    &[disabled] {
      opacity: 0.7;
      pointer-events: none;
    }
      
    i {
      margin: 0 5px;
    }
  }
`;

export const Button: FunctionComponent<ButtonProps> = (props) => {
    const theme: Theme = useContext(ThemeContext).theme;

    return (
        <StyledButton theme={theme} {...props} className={`${props.className} button`} />
    );
}
